import { render, staticRenderFns } from "./ImportExportHeader.vue?vue&type=template&id=fb55e83e"
import script from "./ImportExportHeader.vue?vue&type=script&lang=js"
export * from "./ImportExportHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports